module.exports = __webpack_public_path__ + "static/media/skyna.3a489954.JPG";